<template>
    <div class="card">
        <card>
            <div class="d-flex justify-content-between border-bottom pb-1 mb-5">
                <h4 slot="header" class="card-title">{{this.$route.params.id === undefined ? 'Ajout' : 'Modification'}} d'un produit</h4>
                <n-button slot="header" type="primary" class="btn btn-sm btn-primary mt-4 h-25" @click.native="backToList()">
                    Retour
                </n-button>
            </div>
            <div class="d-flex justify-content-center">
                <form>
                    <div class="mb-3">
                        <label for="name" class="input-label">
                            Produit
                        </label>
                        <fg-input id="name" v-model="product.name"></fg-input>
                    </div>
                    <div class="mb-3">
                        <label for="reference" class="input-label">
                            Référence
                        </label>
                        <fg-input id="reference" v-model="product.reference"></fg-input>
                    </div>
                    <div class="mb-3">
                        <label class="input-label">
                            Fournisseurs
                        </label>
                        <fg-input class="select" name="supplier_id" v-model="product.suppliers_id">
                             <el-select id="supplier" :class="errors.first('supplier_id') ? 'has-error' : ''" placeholder="Choisir un fournisseur" v-model="product.suppliers_id" filterable multiple>
                                <el-option v-for="supplier in supplier.options" :key="supplier.id"
                                    :label="supplier.num + ' - ' + supplier.name"
                                    :value="supplier.id">
                                </el-option>
                            </el-select>
                        </fg-input>
                    </div>
                    <div class="text-center"> 
                        <n-button class="btn btn-sm btn-primary radius" @click.native="save()">
                            Enregistrer
                        </n-button>
                    </div>
                </form>
            </div>
        </card>
    </div>
</template>
<script>
import Form from 'vform'
import { Select, Option } from 'element-ui'

export default {
    name:'ProductForm',
    components: {
        [Select.name]: Select,
        [Option.name]: Option,
    },
    data() {
        return {
            product: new Form({
                id: '',
                reference: '',
                name: '',
                suppliers_id: []
            }),


            supplier: {
                options: []
            },
        }
    },
    mounted() {
        //récupération du détails d'un produit pour la modification
        if(this.$route.params.id !== undefined){
            this.axios.get(process.env.VUE_APP_API_BASE_URL + `fnc/product/` + this.$route.params.id).then((response) => {
                let product = response.data
                

                this.product.id = this.$route.params.id
                this.product.reference = product.reference
                this.product.name = product.name
                this.product.suppliers_id = product.suppliers.map(supplier => supplier.id)
            })
        }

        this.axios.get(process.env.VUE_APP_API_BASE_URL + `fnc/supplier/list`).then((response) => {

            this.supplier.options = response.data
        })
    },
    methods: {
        backToList(){
            this.$router.push({ name: 'fnc admin', params: { selected: "product"} })            
        },

        save(){
            //fonction permettant la modification d'un produit 
            if(this.$route.params.id !== undefined){
                this.product.post(process.env.VUE_APP_API_BASE_URL + `product/update/` + this.$route.params.id).then((response => {
                    this.$notify({ message: 'Le produit à bien été mmodifié', type: "success", verticalAlign: "bottom" })
                    // Pour le moment je reviens toujours sur les liste des produits
                    this.backToList()
                }))
            //fonction permettant l'ajout d'un produit 
            } else {
                this.product.post(process.env.VUE_APP_API_BASE_URL + `product/add`).then((response => {
                    this.$notify({ message: 'Le produit à bien été enregistré', type: "success", verticalAlign: "bottom" })
                    this.backToList()
                }))
            }
        }
    },
}
</script>

<style>
    .input-label {
        margin-left: 1rem;
        position: absolute;
        margin-top: -0.5rem;
        background: white;
        z-index: 4;
        padding-right: 3px;
        padding-left: 3px;
        border-radius: 5px;
    }
    .has-error .el-input .el-input__inner {
        border-color: #ffcfcf !important;
        color: #FF3636 !important;
        background-color: rgba(222, 222, 222, 0.1) !important;
    }

    .has-error .el-input i.el-select__caret {
        color: #FF3636 !important;
    }

    /* .select{
        color: #000;
        background-color: #ffffff;
        border: 1px solid #d3d3d3;
        height: 2rem;
    } */
</style>